// @flow
import React, {useState} from 'react';
import {Collapse, Divider, makeStyles} from '@material-ui/core';

import {ExpandLessRounded, ExpandMoreRounded} from '@material-ui/icons';
import {colors} from '../../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';

type Props = {
  children: React$Element<any>,
  leftContent: React$Node,
  rightContent?: React$Node,
  startClosed?: boolean,
};

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
    },
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 2),
    },
  },
  header: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '100%',
    alignItems: 'center',
  },
  rightContent: {
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    marginTop: theme.spacing(1),
    background: colors.grey300,
  },
}));

export default function Section(props: Props) {
  const {leftContent, children, startClosed = true, rightContent} = props;
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(startClosed);

  const handleOpen = () => setOpen(o => !o);
  return (
    <section className={classes.section}>
      <div className={classes.header} onClick={handleOpen}>
        <div className={classes.leftContent}>{leftContent}</div>
        <div className={classes.rightContent}>
          {rightContent && (
            <div className={classes.rightContent}>{rightContent}</div>
          )}
          {open ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        </div>
      </div>

      <Collapse in={open}>
        <Divider className={classes.divider} />
        <div className={classes.content}>{children}</div>
      </Collapse>
    </section>
  );
}
